export default __webpack_public_path__ + "static/media/Credit_Dark2.802e7542.svg";